





















































import { Component, Prop, Vue } from "vue-property-decorator";
import websocket from "@/../api/websocket";
import UserCard from "./UserCard.vue";
import { RoomData } from "../../api/data";
import roomStore from "@/../api/room.store";
import voteStore from "@/../api/vote.store";

@Component({ components: { UserCard } })
export default class Room extends Vue {
  @Prop(String) readonly roomName: string;

  roomStatus = roomStore.room(this.roomName);
  vote = voteStore.getOwnVote(this.roomName);
  selected = "";
  votingDone = false;

  numbers: number[] = [0, 1, 2, 3, 5, 8, 13, 21];

  onVotingResults(roomData: RoomData) {
    if (this.roomName == roomData.room_name) {
      this.votingDone = true;
    }
  }

  onNewVote(roomData: RoomData) {
    if (this.roomName == roomData.room_name) {
      this.votingDone = false;
      this.selected = "";
    }
  }

  onRandomized(roomData: RoomData) {
    if (this.roomName == roomData.room_name) {
      this.selected = roomData.selected_user_id;
      if ("speechSynthesis" in window) {
        this.roomStatus.users.forEach(user => {
          if (user.user_id == this.selected) {
            const msg = new SpeechSynthesisUtterance();
            msg.text = "It is " + user.name;
            msg.lang = "en-US";
            window.speechSynthesis.speak(msg);
          }
        });
      }
    }
  }

  created() {
    websocket.on("VoteResults", this.onVotingResults);
    websocket.on("NewVote", this.onNewVote);
    websocket.on("Randomized", this.onRandomized);
  }

  castVote(value) {
    websocket.vote(this.roomName, value);
  }

  requestNewVote() {
    websocket.newVote(this.roomName);
  }

  randomize() {
    websocket.randomize(this.roomName);
  }
}
